export const ITEMS_PER_PAGE = {
  videos: 21,
  terms: 60,
  sitemapPortal: 1000,
  newsByTag: 12,
  newsByAuthor: 12,
  newsByCategory: 12,
  latestNews: 12,
  podcasts: 12,
  sitemaps: 10000
};
